<basin-pull-down-container>
	<ng-container slot="main">
		<div
      class="basin-display-flex basin-flex-row basin-justify-content-space-between basin-align-items-center basin-width-100 basin-pb-1"
    >
			<div>
				<div class="basin-flex-column">
					<div class="basin-font-secondary basin-color-true-white basin-font-size-20 basin-font-weight-700 basin-pb-1">
            Simulation
          </div>
					<div
            [ngClass]="{ 'basin-color-green-75': isCompleted, 'basin-color-warning': !isCompleted }"
            class="basin-font-uppercase basin-font-weight-500"
          >
            {{ getStatus() }} &nbsp;
          </div>
				</div>
			</div>
			<div class="p-d-flex p-jc-center p-ai-center basin-height-100">
				<h1
          [ngClass]="{ 'basin-color-orange': !isCompleted, 'basin-color-green-75': isCompleted }"
          class="basin-font-size-48 basin-font-weight-700"
          *ngIf="isInLoop"
        >
          {{ progressPercentage | number : "1.0-1" }}%
        </h1>
			</div>
		</div>

		<div
      class="basin-display-flex basin-justify-content-space-between basin-align-items-center"
      *ngIf="isInLoop"
    >
			<div
        class="basin-subtitle-small basin-font-weight-400 basin-color-green-75"
      >
        Time to Completion
      </div>
			<span class="basin-body-small basin-color-green-75">
        {{ formatTime(simulationStatus?.estimatedTimeRemainingLog) }}
      </span>
		</div>
	</ng-container>

	<ng-container slot="drawer">
    <ng-container
      #simulation
      *ngIf="
        (selectedStudyArea$ | async) &&
        (isInLoop ||
          simulationLoopService.getSimulationStatus().iterations > 0)
      "
      class="basin-pt-1"
    >
      <app-simulation-loop-details></app-simulation-loop-details>
    </ng-container>
    <ng-container #simulation *ngIf="showSimulationDetails()">
      <app-simulation-details></app-simulation-details>
    </ng-container>
	</ng-container>
</basin-pull-down-container>
